export default __webpack_public_path__ + "static/media/icon_checkbox.e4b9c5c2.svg";